import React from "react";
import { Box, Button, styled, Typography } from "@mui/material";
import { useAuth } from "../../../contexts/AuthProvider/AuthProvider";

const CustomBox = styled(Box)(({ theme }) => ({
  height: "100vh",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
}));

const handleOnClick = () => {
  localStorage.clear();
  window.location.href = "/auth/login";
};
export const NoBillingComapnyScreen: React.FC<{}> = () => {
  return (
    <CustomBox>
      <Typography variant="h4" sx={{ fontWeight: 600 }}>
        Ooops..! It Seems you don't have valid Billing Company.
      </Typography>
      <Typography variant="h6">Please contact your admin</Typography>
      <Typography variant="h6">or</Typography>
      <Typography variant="h6" sx={{ mb: 2 }}>
        <Button variant="text" onClick={handleOnClick}>
          Login
        </Button>{" "}
        with different account to continue
      </Typography>
    </CustomBox>
  );
};
